import React from 'react';
import styled from 'styled-components';

import elementSize from './elementSize';

export default styled(({ minimal, ...rest }) => <div {...rest} />)`
  position: absolute;
  right: 0;
  top: ${({ minimal }) => (minimal ? '1px' : 'calc(1px + 1.5rem)')};
  width: ${elementSize};
  cursor: pointer;

  &:hover .code-description {
    display: block;
  }
`;
